export { FittedImage, type FittedImageProps } from "./FittedImage"
